import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'single-selector-tree-view',
    templateUrl: './single-selector-tree-view.component.html',
    styleUrls: ['./single-selector-tree-view.component.scss']
})
export class SingleSelectorTreeViewComponent implements OnInit {

    @Input() expandedKeys: any[];
    @Input() selectedId: number;
    @Input() displayName: string;
    @Input() enableAllNodes: boolean = false;
    @Input() searchKey: string = "name";
    @Input() data: any;
    @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor() { }

    public ngOnInit(): void {
        if(this.enableAllNodes){
            this.enableAll(this.data);
        }
    }

    ngAfterContentInit() {
        this.addExpandListItem(this.data);
    }

    showClick(dataItem: any) {
        this.closeEvent.emit(dataItem);
    }

    private addExpandListItem(treeItem: any) {
        treeItem.forEach(item => {
            if (item.hasChild) {
                this.addExpandListItem(item.items)
            }
        });
    }

    public enableAll(data: Array<any>) {
        data.map(item => {
            item.isSelectable = true;
            this.enableAll(item.items);
        })
    }
}
